import React from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import { PropTypes } from 'prop-types';
import { Button, FormGroup, Form } from 'reactstrap';

import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import Select from '../../../common/forms/select/Select';

const validateCompanyResourceOrGroup = (value, allValues) => {
  const { companyResourceId, companyResourceGroupId } = allValues;

  const isNotEmpty = (val) => {
    if (val === null || val === undefined) {
      return false;
    }

    if (Array.isArray(val)) {
      return val.length > 0;
    }

    if (typeof val === 'object') {
      return Object.keys(val).length > 0;
    }

    return val !== '';
  };

  const validFields = [companyResourceId, companyResourceGroupId].filter(
    isNotEmpty,
  );

  if (validFields.length === 0) {
    return 'Debe seleccionar Recursos de Compañía o Grupo de Recursos de Compañía.';
  }

  if (validFields.length > 1) {
    return 'Solo debe seleccionar Recursos de Compañía o Grupo de Recursos de Compañía.';
  }

  return undefined;
};

const EndPreventiveTaskResourceForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  companyResourceOptions,
  companyResourceGroupOptions,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <p>Seleccione los recursos que desea desactivar de la tarea preventiva</p>
    <hr />

    <FormGroup row className="mt-4">
      <FormItem label="Recursos de Compañía">
        <Field
          name="companyResourceId"
          component={Select}
          isClearable
          isMulti
          placeholder="Recursos de Compañía"
          validate={[validateCompanyResourceOrGroup]}
          options={companyResourceOptions}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row className="mt-4">
      <FormItem label="Grupo de Recursos de Compañía">
        <Field
          name="companyResourceGroupId"
          component={Select}
          isClearable
          isMulti
          placeholder="Grupo de Recursos de Compañía"
          validate={[validateCompanyResourceOrGroup]}
          options={companyResourceGroupOptions}
        />
      </FormItem>
    </FormGroup>

    <FormFooter
      saveButtonColor="warning"
      saveButtonIcon="fa fa-check-circle"
      saveButtonText="Desactivar"
    >
      <Button color="primary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

EndPreventiveTaskResourceForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  companyResourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  companyResourceGroupOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

EndPreventiveTaskResourceForm.defaultProps = {
  companyResourceOptions: [],
  companyResourceGroupOptions: [],
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'EndPreventiveTaskResourceForm',
})(EndPreventiveTaskResourceForm);

export default connect(null, mapDispatchToProps)(formComponent);
